import { EDITION_TYPES } from '../constants/features.constants';

const editionList = [EDITION_TYPES.ULTIMATE, EDITION_TYPES.MAX, EDITION_TYPES.PRO, EDITION_TYPES.FREE_TRIAL];

export const transformCompatibility = (editionValidation) => {
    const featureEditions = {};
    let resourceEditions = [];

    // Max, Pro, MaxClassic, FreeTrial, All are values from the backend
    const {
        Max: max, Pro: pro, MaxClassic: ultimate, FreeTrial: freeTrial, All: all,
    } = editionValidation;

    // unique list of features required for this resource
    const allFeatures = [...new Set([...max, ...pro, ...ultimate, ...freeTrial, ...all])];

    allFeatures.forEach((feature) => {
        const editions = [];

        if (all.includes(feature)) {
            editions.push(EDITION_TYPES.ALL);
        } else {
            // the order of editions being added is important
            if (ultimate.includes(feature)) {
                editions.push(EDITION_TYPES.ULTIMATE);
            }

            if (max.includes(feature)) {
                editions.push(EDITION_TYPES.MAX);
            }

            if (pro.includes(feature)) {
                editions.push(EDITION_TYPES.PRO);
            }

            if (freeTrial.includes(feature)) {
                editions.push(EDITION_TYPES.FREE_TRIAL);
            }
        }

        featureEditions[feature] = editions;
    });

    editionList.forEach((edition) => {
        // if all required features have this edition, the resoure is compatible with the edition
        const featuresHaveEdition = Object.keys(featureEditions).every((feature) => {
            return featureEditions[feature].includes(edition) || featureEditions[feature].includes(EDITION_TYPES.ALL);
        });

        if (featuresHaveEdition) {
            resourceEditions.push(edition);
        }
    });

    if (resourceEditions.length === editionList.length) {
        resourceEditions = [EDITION_TYPES.ALL];
    }

    return {
        resourceEditions,
        featureEditions,
    };
};

// takes in a list of resourceEditions [[MAX, PRO], [ULTIMATE, PRO]]
// returns a list of which editions are compatible with all [PRO]
export const transformCompatibilityRollup = (resourceEditionsList) => {
    let rollup = [];

    editionList.forEach((edition) => {
        if (resourceEditionsList.every((resourceEditions) => resourceEditions.includes(edition) || resourceEditions.includes(EDITION_TYPES.ALL))) {
            rollup.push(edition);
        }
    });

    if (rollup.length === editionList.length) {
        rollup = [EDITION_TYPES.ALL];
    }

    return rollup;
};
